/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../common";
import type {
  L2MessageContractArbitrum,
  L2MessageContractArbitrumInterface,
} from "../L2MessageContractArbitrum";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_l1Messenger",
        type: "address",
      },
      {
        internalType: "contract IStkEth",
        name: "_stkETH",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "NotCrossDomain",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "block",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "cValueChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "stkETHMinted",
    type: "event",
  },
  {
    inputs: [],
    name: "L1Messenger",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_cValue",
        type: "uint256",
      },
    ],
    name: "changeCValue",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "mintstkETH",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "stkETH",
    outputs: [
      {
        internalType: "contract IStkEth",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type L2MessageContractArbitrumConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: L2MessageContractArbitrumConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class L2MessageContractArbitrum__factory extends ContractFactory {
  constructor(...args: L2MessageContractArbitrumConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _l1Messenger: PromiseOrValue<string>,
    _stkETH: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<L2MessageContractArbitrum> {
    return super.deploy(
      _l1Messenger,
      _stkETH,
      overrides || {}
    ) as Promise<L2MessageContractArbitrum>;
  }
  override getDeployTransaction(
    _l1Messenger: PromiseOrValue<string>,
    _stkETH: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_l1Messenger, _stkETH, overrides || {});
  }
  override attach(address: string): L2MessageContractArbitrum {
    return super.attach(address) as L2MessageContractArbitrum;
  }
  override connect(signer: Signer): L2MessageContractArbitrum__factory {
    return super.connect(signer) as L2MessageContractArbitrum__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): L2MessageContractArbitrumInterface {
    return new utils.Interface(_abi) as L2MessageContractArbitrumInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): L2MessageContractArbitrum {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as L2MessageContractArbitrum;
  }
}
